module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "software-list"
  }, _vm._l((_vm.value), function(software) {
    return _c('li', [(software.href) ? _c('router-link', {
      staticClass: "software-wrapper",
      attrs: {
        "to": software.href
      }
    }, [_c('software-item', {
      attrs: {
        "software": software
      }
    })], 1) : _c('div', {
      staticClass: "software-wrapper"
    }, [_c('software-item', {
      attrs: {
        "software": software
      }
    })], 1)], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d1d336d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/software-list/index.vue
// module id = 1987
// module chunks = 2